import { ActionIcon, Flex, Popover, Text } from '@mantine/core'
import { useTranslations } from 'next-intl'
import { useState } from 'react'

import External from '@/assets/icons/external.svg'
import { MarketPair, ResourceLink, SocialLinkType } from '@/types/resource'

import MarketModal from './MarketModal'
import styles from './style.module.css'

export type LinkItem = { name: string; url: string }

interface CoinMetaDetailsProps {
  socialData: ResourceLink
  marketPair: MarketPair[]
}

export default function CoinMetaDetails({ socialData, marketPair }: CoinMetaDetailsProps) {
  const { label, name, urlDomains, urls } = socialData
  const [opened, setOpened] = useState(false)
  const [openedModal, setOpenedModal] = useState(false)
  const t = useTranslations('about')

  if (!socialData) return null

  if (name === SocialLinkType.Markets && marketPair.length > 0) {
    return (
      <>
        <Text variant="subtitle" c="var(--text-secondary)">
          {label}
        </Text>
        <Text
          variant="body"
          c="var(--content-active, --common-primary)"
          onClick={() => setOpenedModal(true)}
          style={{ cursor: 'pointer' }}
        >
          {t('resources.view')}
        </Text>
        <MarketModal data={marketPair} opened={openedModal} onClose={() => setOpenedModal(false)} />
      </>
    )
  }

  return (
    <>
      <Text variant="subtitle" c="var(--text-secondary)">
        {label}
      </Text>
      {urls.length === 1 ? (
        <Text
          variant="subtitle-paragraph"
          c="var(--content-active, --common-primary)"
          onClick={() => window.open(urls[0], '_blank')}
          style={{ cursor: 'pointer' }}
        >
          {t('resources.view')}
        </Text>
      ) : (
        <Popover
          opened={opened}
          onChange={setOpened}
          position="bottom-start"
          shadow="md"
          withinPortal
          width={220}
          classNames={{ dropdown: styles.dropdownContent }}
        >
          <Popover.Target>
            <Text
              variant="subtitle-paragraph"
              c="var(--content-active, --common-primary)"
              style={{ cursor: 'pointer', width: 'fit-content' }}
              onClick={() => setOpened(o => !o)}
            >
              {t('resources.view')}
            </Text>
          </Popover.Target>
          <Popover.Dropdown>
            {urlDomains?.map((item, idx) => (
              <Flex
                key={idx}
                align="center"
                justify="space-between"
                px={20}
                py={12}
                style={{
                  borderBottom:
                    idx !== urlDomains.length - 1
                      ? '1px solid var(--border-surface-default)'
                      : 'none',
                  cursor: 'pointer',
                  textDecoration: 'none',
                }}
                component="a"
                href={item.url}
                target="_blank"
                rel="noopener noreferrer"
                onClick={() => setOpened(false)}
              >
                <Text variant="subtitle-paragraph" c="var(--text-primary)">
                  {item.domain}
                </Text>
                <ActionIcon variant="subtle" color="gray" size={22}>
                  <External size={18} />
                </ActionIcon>
              </Flex>
            ))}
          </Popover.Dropdown>
        </Popover>
      )}
    </>
  )
}
